<template>
  <!-- Modal other files -->
  <div class="modal fade" id="what-is-boi" tabindex="-1" role="dialog" aria-labelledby="whatIsBoi" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div>
          <div class="modal-header">
            <span class="modal-title-new" id="termsLabel">{{ $t('BOI Form Nedir? Neden Başvurmalıyım?') }}</span>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body modal-body-min">
            <div class="top-info-field">
              <div class="top-info-field-left">
                <img src="/img/boi.svg" alt="" />
              </div>
              <div class="top-info-field-right">
                <span class="top-info-field-header">BOI (Beneficial Ownership Information), </span>
                <span class="top-info-field-text"> {{ $t('BOI Açıklama') }}</span>
              </div>
            </div>
            <div class="alert-field-new">
              <div>
                <img src="/img/icons/goal.svg" alt="" />
              </div>
              <span class="alert-text-new">
                {{
                  $t(
                    'Kuruluş paketinde şirket kuruluşunun ardından ihtiyacınız olacak EIN ve BOI Form hizmetlerini birlikte satın alarak %28 tasarruf sağlayabilirsiniz'
                  )
                }}
              </span>
            </div>
            <div class="features-field">
              <div class="features-top-field">
                <div class="features-top-field-header">{{ $t('Neden Yaptırmalıyım') }}</div>
                <div class="features-top-field-text">
                  {{ $t('BOI Form bildirimi yapmanın birçok önemli nedeni vardır') }}
                </div>
              </div>
              <div class="features-item" v-for="(feature, index) in features" :key="index">
                <div>
                  <span class="features-header-item">{{ feature.header }}: </span>
                  <span class="features-text-item">{{ feature.text }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn button-type-outline-light" data-dismiss="modal">
            {{ $t('Kapat') }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal terms -->
</template>
<script>
export default {
  name: 'whatIsEin',
  props: {},
  data() {
    return {
      features: this.$t('BOI Nedir Maddeleri'),
    };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
.top-info-field {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  text-align: left;
  @media (max-width: 576px) {
    align-items: center;
    text-align: center;
    flex-direction: column;
  }

  .top-info-field-header {
    color: black;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
  .top-info-field-text {
    color: #868686;
    font-size: 14px;
    line-height: 21px;
  }
}
.modal-dialog {
  max-width: 659px !important;
  padding: 8px !important;
}
.alert-field-new {
  margin-top: 24px;
  background: rgba(0, 170, 107, 0.1);
  border-radius: 12px;
  border: 1px solid #ddd;
  padding: 16px;
  display: flex;
  gap: 8px;
}

.modal-title-new {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  font-weight: 500;
  color: black;
}

.features-field {
  margin-top: 24px;
  background: #f9f9f9;
  border-radius: 16px;
  padding: 16px 16px 16px 16px;
  .features-top-field {
    margin-bottom: 8px;
    .features-top-field-header {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: black;
    }
    .features-top-field-text {
      color: #868686;
      font-size: 14px;
      line-height: 21px;
      margin-top: 8px;
    }
  }
}

.features-item {
  padding-top: 12px;

  .features-header-item {
    font-size: 14px;
    color: black;
    line-height: 21px;
    font-weight: 500;
  }
  .features-text-item {
    margin-top: 8px;
    font-size: 14px;
    color: #868686;
    line-height: 21px;
  }
}
</style>
